import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreModule } from '@ngrx/store';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authReducer } from './store/reducers/auth.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './store/effects/auth.effects';
import { SharedPrimengModule } from './shared/shared-primeng.module';
import { ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withFetch,
} from '@angular/common/http'; // Import HttpClientModule

import { CoreModule } from './core/core.module';
import { FeaturesModule } from './features/features.module';
import { SharedModule } from './shared/shared.module';
import { LoadingspinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { MessageService } from 'primeng/api';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DialogService } from 'primeng/dynamicdialog';

import {
  spinnerReducer,
  warningReducer,
} from './store/reducers/warning.reducer';
import { WarningEffects } from './store/effects/warning.effects';
import { appReducer } from './store/common/app.reducer';
import { AppEffects } from './store/common/app.effects';
import { HomeEffects } from './store/effects/home.effects';
import { homeReducer } from './store/reducers/home.reducer';
import { SignalREffects } from './store/effects/signal-r.effects';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { PiDataReducer } from './store/reducers/pi-data.reducer';
import { PiDataEffects } from './store/effects/pi-data.effects';
import { sedEventsReducer } from './store/reducers/sed-events.reducer';
import { SedEventsEffects } from './store/effects/sed-events.effects';
import { SpinnerInterceptor } from './auth/interceptor/spinner-interceptor';
import { AuthInterceptor } from './auth/interceptor/interceptor';
import { rulesReducer } from './store/reducers/rules.reducer';
import { RulesEffects } from './store/effects/rules.effects';
import { IconsModule } from './shared/icons.module';
import { providePrimeNG } from 'primeng/config';
import LaraLightBlue from '../lara-light-blue';
import { ToastModule } from 'primeng/toast';
import { discussionsReducer } from './store/reducers/discussion.reducer';
import { DiscussionsEffects } from './store/effects/discussion.effects';
import { AlarmEffects } from './store/effects/alarm.effects';
import { PotentialCauseEffects } from './store/effects/potential-cause.effects';
import { potentialCauseReducer } from './store/reducers/potential-cause.reducer';
import { CorrectiveActionEffects } from './store/effects/corrective-action.effects';
import { correctiveActionReducer } from './store/reducers/corrective-action.reducer';
import { TimeBasedWorkPropositionEffects } from './store/effects/time-based-work-proposition.effects';
import { timeBasedWorkPropositionReducer } from './store/reducers/time-based-work-proposition.reducer';
import { RuleResultEffects } from './store/effects/rule-result.effects';
import { ruleResultReducer } from './store/reducers/rule-result.reducer';
import { potentialConsequenceReducer } from './store/reducers/potential-consequence.reducer';
import { PotentialConsequenceEffects } from './store/effects/potential-consequence.effects';
import { plantReducer } from './store/reducers/plant.reducer';
import { PlantEffects } from './store/effects/plant.effects';

@NgModule({
  declarations: [AppComponent, LoadingspinnerComponent],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastModule,
    ToastModule,
    AppRoutingModule,
    StoreModule.forRoot({
      auth: authReducer,
      spinner: spinnerReducer,
      warning: warningReducer,
      app: appReducer,
      home: homeReducer,
      piData: PiDataReducer,
      sedEvents: sedEventsReducer,
      rules: rulesReducer,
      plant: plantReducer,
      discussions: discussionsReducer,
      potentialCause: potentialCauseReducer,
      potentialConsequence: potentialConsequenceReducer,
      correctiveAction: correctiveActionReducer,
      timeBasedWorkProposition: timeBasedWorkPropositionReducer,
      RuleResult: ruleResultReducer,
    }),
    EffectsModule.forRoot([
      AuthEffects,
      WarningEffects,
      AppEffects,
      HomeEffects,
      SignalREffects,
      PiDataEffects,
      SedEventsEffects,
      RulesEffects,
      PlantEffects,
      DiscussionsEffects,
      AlarmEffects,
      PotentialCauseEffects,
      PotentialConsequenceEffects,
      CorrectiveActionEffects,
      TimeBasedWorkPropositionEffects,
      RuleResultEffects,
    ]),
    SharedModule,
    SharedPrimengModule,
    ReactiveFormsModule,
    CoreModule,
    FeaturesModule,
    HttpClientModule,
    IconsModule,
  ],
  providers: [
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withFetch()),
    providePrimeNG({
      theme: {
        preset: LaraLightBlue,
        options: {
          prefix: 'p',
          darkModeSelector: '.my-app-dark',
          cssLayer: false,
        },
      },
      ripple: true,
    }),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },

    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    MessageService,
    DialogService,
    provideCharts(withDefaultRegisterables()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
